import { useState, useCallback } from "react";
import { getPaginatedBlogs, getBlogBySlug, getHomeBlog } from "@/actions";
import { toast } from "react-toastify";

const useBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [blog, setBlog] = useState(null);
  const [homeBlog, setHomeBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    pages: 0,
    currentPage: 1,
  });

  const fetchBlogs = useCallback(async (page = 1, limit = 6) => {
    setLoading(true);
    try {
      const response = await getPaginatedBlogs(page, limit);
      if (response?.status === 200) {
        setBlogs(response.data?.data || []);
        setPagination({
          total: response.data?.total || 0,
          pages: response.data?.pages || 0,
          currentPage: response.data?.currentPage || 1,
        });
      } else {
        toast.error(response?.message || "Failed to fetch blogs");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong while fetching blogs");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchBlogBySlug = useCallback(async (slug) => {
    setLoading(true);
    try {
      const response = await getBlogBySlug(slug);
      if (response?.status === 200) {
        setBlog(response.data || null);
      } else {
        toast.error(response?.message || "Failed to fetch blog details");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong while fetching blog details");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchHomeBlog = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getHomeBlog();
      if (response?.responseCode === 1) {
        setHomeBlog(response.data || null);
      }
    } catch (err) {
      console.log("Failed to fetch home blog", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    blogs,
    blog,
    homeBlog,
    loading,
    pagination,
    fetchBlogs,
    fetchBlogBySlug,
    fetchHomeBlog,
  };
};

export default useBlogs;
